export default __webpack_public_path__ + "static/media/song2_img.3010f68e.jpg";